// extracted by mini-css-extract-plugin
export var label = "_et-5";
export var slideContainer = "_et-0";
export var slider = "_et-1";
export var sliderLg = "_et-4";
export var sliderMd = "_et-3";
export var sliderSm = "_et-2";